import React from 'react';
import { Translate } from '@pegasus/translation';
import classNames from 'classnames/bind';
import { SEC_SUB_SUCCESS_PLACEMENT } from '@client/config/constants';
import InfoBox from '@client/components/shared/InfoBox';
import styles from './styles.scss';

import { useStep, Step, MessageProps } from './hooks';

const cn = classNames.bind(styles);

export const SecondarySubscriptionMessage = (props: MessageProps) => {
    const { placement, pending, close } = props;

    const { step } = useStep(props);

    const {
        onAccept,
        onReject = null,
        text,
        title,
        iconComponent,
        yesMessage = 'messageYes',
        noMessage = 'messageNo',
        placeholder = false,
    }: Step = step;

    const isSuccessPage = placement === SEC_SUB_SUCCESS_PLACEMENT;

    return (
        <div className={cn('wrapper')}>
            <InfoBox
                title={title}
                iconComponent={iconComponent}
                onCloseClick={close}
                noCloseIcon={isSuccessPage}
                inline={isSuccessPage}
                pending={pending || !step}
            >
                {step && (
                    <>
                        <div>
                            <Translate message={text} html />
                        </div>
                        {placeholder && <div className={cn('button-placeholder')} />}
                        {onAccept && (
                            <button
                                type="button"
                                className={cn('button', 'primary')}
                                onClick={onAccept}
                            >
                                <Translate message={yesMessage} html />
                            </button>
                        )}
                        {onReject && (
                            <button
                                type="button"
                                className={cn('button', 'secondary')}
                                onClick={onReject}
                            >
                                <Translate message={noMessage} html />
                            </button>
                        )}
                    </>
                )}
            </InfoBox>
        </div>
    );
};

export default SecondarySubscriptionMessage;
